import { defineMessages } from 'react-intl';

const scope = 'app.containers.admin.AccountManagement.LySpit';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'LYSPIT',
    },
    description: {
        id: `${scope}.description`,
        defaultMessage: 'Current vs LYSPIT for this month. Click row for more detail',
    },
    nameColumnTitle: {
        id: `${scope}.nameColumnTitle`,
        defaultMessage: 'Property',
    },
    currentColumnTitle: {
        id: `${scope}.currentColumnTitle`,
        defaultMessage: 'Current',
    },
    lyspitColumnTitle: {
        id: `${scope}.lyspitColumnTitle`,
        defaultMessage: 'LYSPIT',
    },
    diffColumnTitle: {
        id: `${scope}.diffColumnTitle`,
        defaultMessage: 'Difference',
    },
    graphCurrent: {
        id: `${scope}.graphCurrent`,
        defaultMessage: 'Current',
    },
    graphLySpit: {
        id: `${scope}.graphLySpit`,
        defaultMessage: 'LYSPIT',
    },
});
